import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import ProfileFoldout from 'components/organisms/Foldouts/ProfileFoldout/ProfileFoldout';

const StyledTaskProfileFoldout = styled(ProfileFoldout)`
  ${ComponentStyles}
`;

StyledTaskProfileFoldout.propTypes = {
  theme: PropTypes.object
};

export default StyledTaskProfileFoldout;
